import * as React from 'react';

const SvgNotFoundPageIcon = (props) => (
  <svg
    width={180}
    height={75}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M56.349 57.935V44.348h-7.734V1.087H28.727L0 45.978v11.957h33.146v15.978h15.469V57.935h7.734ZM33.146 44.348H16.573l16.573-25.544v25.544ZM89.227 63.044c9.944 0 13.59-7.066 13.59-26.631 0-17.935-2.542-24.456-12.485-24.456-9.944 0-13.038 7.065-13.038 26.63 0 17.935 1.989 24.456 11.933 24.456ZM90.884 0c15.468 0 27.29 9.783 27.29 36.413 0 26.63-10.717 38.587-29.5 38.587-15.468 0-26.848-9.783-26.848-36.413C61.826 11.957 72.1 0 90.884 0ZM180 57.935V44.348h-7.734V1.087h-19.888l-28.727 44.891v11.957h33.147v15.978h15.468V57.935H180Zm-23.202-13.587h-16.574l16.574-25.544v25.544Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgNotFoundPageIcon;
